import script from "./AdminImportQuestions.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminImportQuestions.vue?vue&type=script&setup=true&lang=js"

import "./AdminImportQuestions.vue?vue&type=style&index=0&id=df935c30&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df935c30"]])

export default __exports__